<template>
  <v-card elevation="0" rounded="lg" outlined>
    <slot name="header">
      <v-card-title class="card-title">
        <slot name="icon">
          <svg-icon name="star" color="#0E1452" class="ml-2"></svg-icon>
        </slot>

        <slot name="title">
          <span class="title-text">{{ title }}</span>
        </slot>

        <v-spacer></v-spacer>

        <slot name="headerActionBtn">
          <v-menu v-if="editable && deletable">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon color="#0E1452" v-bind="attrs" v-on="on">
                <v-icon size="20">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dark class="pa-0">
              <v-list-item
                v-for="(item, index) in menuOptions"
                :key="index"
                dense
                class="menu-list-item px-2"
                @click="$emit(item.event, id)"
              >
                <span class="ml-2 center">
                  <svg-icon
                    :name="item.icon"
                    color="#ffffff"
                    width="18"
                    height="18"
                  ></svg-icon>
                </span>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            v-else-if="deletable"
            icon
            color="#0E1452"
            @click="$emit('delete', id)"
          >
            <svg-icon name="delete" color="#0E1452"></svg-icon>
          </v-btn>

          <v-btn
            v-else-if="editable"
            icon
            color="#0E1452"
            @click="$emit('edit', id)"
          >
            <svg-icon name="edit" color="#0E1452"></svg-icon>
          </v-btn>
        </slot>
      </v-card-title>
    </slot>

    <v-divider></v-divider>

    <slot name="content">
      <v-card-text class="pt-2">
        <div
          v-for="(item, i) in contentItems"
          :key="i"
          class="center-right content-text"
        >
          <div class="ml-2 mb-auto mt-2">
            <svg-icon
              :name="item.icon"
              color="rgba(0, 0, 0, 0.5)"
              width="20"
              height="20"
            ></svg-icon>
          </div>

          {{ item.text }}
        </div>
      </v-card-text>
    </slot>

    <slot name="action"></slot>
  </v-card>
</template>

<script>
export default {
  name: "ListItemCard",
  emits: ["delete", "edit"],
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    phone: {
      type: String,
      required: false,
    },
    address: {
      type: String,
      required: false,
    },
    deletable: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      menuOptions: [
        { title: "ویرایش", event: "edit", icon: "edit" },
        { title: "حذف", event: "delete", icon: "delete" },
      ],
    };
  },

  computed: {
    contentItems() {
      let items = [];

      const name = this.createObj("name");
      const phone = this.createObj("phone");
      const address = this.createObj("address");

      if (name) items.push(name);
      if (phone) items.push(phone);
      if (address) items.push(address);

      return items;
    },
  },

  methods: {
    createObj(propertyKey) {
      const value = this[propertyKey];
      if (!value) return;

      return {
        text: value,
        icon: this.getIconName(propertyKey),
      };
    },
    getIconName(key) {
      switch (key) {
        case "name":
          return "person";

        case "phone":
          return "phone";

        case "address":
          return "location";
      }
    },
  },
};
</script>

<style scoped>
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-title {
  padding: 4px 16px;
  background-color: rgba(14, 20, 82, 0.06);
}

.title-text {
  color: #0e1452;
  font-style: normal;
  font-weight: 400 !important;
  font-size: 15px;
}

.content-text {
  color: rgba(0, 0, 0, 0.6);
  font-style: normal;
  font-weight: 400 !important;
  font-size: 13px;
}

.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.menu-list-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  min-width: 130px;
}
</style>
